import PositionType from '../model/PositionType';
import m from './module';

class PositionTypeService {
  constructor($q, APIService) {
    this.$q = $q;
  }

  create(data) {
    data = data || {};
    let model = new PositionType(data);
    return this.$q.when(model);
  }
}

export default PositionTypeService;

m.service('PositionTypeService', PositionTypeService);
